import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { WhiteSpace, WingBlank } from "foui";
import styles from "./index.m.scss";
import { Redirect } from "react-router-dom";
import utils from "../../utils/utils";
// import { urlPageCommonWeixinPay } from "../../router/allUrls";
import * as allUrls from "../../router/allUrls";
import LoadingView from "../LoadingView";
import history from "../../router/history";

@observer
class RedirectForPayment extends React.Component {
  render() {
    let { toUrl, paramsToQuery, weixinPayPageType, ...others } = this.props;
    const query = utils.getUrlQuery() || {};
    const routeParams = utils.getRouteParams(this.props);
    Object.entries(paramsToQuery).forEach(([k, v]) => {
      query[v] = routeParams[k];
    });
    Object.assign(query, {
      weixinPayPageType
    });
    query.__t__ = new Date().getTime();

    toUrl = toUrl || allUrls.urlPageCommonWeixinPay;

    const newUrl = toUrl.formatUrl({}, query).replace(/null/g, "");

    // 必须采取整页刷新方式, 因为微信支付授权目录检查的是首次加载的目录
    if (utils.isDingTalk()) {
      history.replace(newUrl);
    } else if (utils.isFoApp()) {
      utils.replaceUrl(newUrl);
    } else {
      setTimeout(() => {
        window.location.replace(newUrl);
      }, 0);
    }
    return <LoadingView loading={true} />;

    return <Redirect {...others} to={newUrl} />;
  }
}

RedirectForPayment.propTypes = {
  weixinPayPageType: PropTypes.string.isRequired,
  toUrl: PropTypes.object,
  paramsToQuery: PropTypes.object.isRequired
};
RedirectForPayment.defaultProps = {
  paramsToQuery: {}
};

export default RedirectForPayment;



// WEBPACK FOOTER //
// ./src/components/RedirectForPayment/index.js